export default __webpack_public_path__ + "static/media/ill-college.124617df.png";